const HDN_ADMIN = "HDN_Admin";
const HDN_INZAGE = "HDN_Inzage"; // Zelfde rechten als HDN_Admin, maar dan read-only
const ORG_ADMIN = "ORG_Admin";
const CONTACTPERSONEN_ADMIN = "Contactpersonenbeheer";
const AUTORISATIE_ADMIN = "Autorisatiebeheer";
const MACHTIGINGEN_ADMIN = "Machtigingenbeheer";
const FACTURATIE_GEGEVENS_BEHEER = "Facturatiegegevensbeheer";
const FACTURATIE_GEGEVENS_INZAGE = "Facturatiegegevensinzage";
const USERMANAGEMENT_REALM_NAME = "usermanagement";
const UPDATE_PASSWORD_ACTION = "UPDATE_PASSWORD";
const DOCUMENTATION_ACCESS = "Documentatieinzage";
const UITZONDERINGENLIJST_ADMIN = "Uitzonderingenbeheer";


const ALL_ORG_FUNCTIONALITIES = [CONTACTPERSONEN_ADMIN, AUTORISATIE_ADMIN, MACHTIGINGEN_ADMIN, FACTURATIE_GEGEVENS_BEHEER, FACTURATIE_GEGEVENS_INZAGE];
const EMPOWERABLE_ADMIN_ROLES = [CONTACTPERSONEN_ADMIN, AUTORISATIE_ADMIN];

export default Object.freeze({
    HDN_ADMIN,
    HDN_INZAGE,
    ORG_ADMIN,
    UITZONDERINGENLIJST_ADMIN,
    CONTACTPERSONEN_ADMIN,
    AUTORISATIE_ADMIN,
    MACHTIGINGEN_ADMIN,
    EMPOWERABLE_ADMIN_ROLES,
    FACTURATIE_GEGEVENS_BEHEER,
    FACTURATIE_GEGEVENS_INZAGE,
    ALL_ORG_FUNCTIONALITIES,
    USERMANAGEMENT_REALM_NAME,
    UPDATE_PASSWORD_ACTION,
    DOCUMENTATION_ACCESS
})